import { ChartData } from '../types/game.types';

/**
 * 이동평균(MA) 계산
 * @param data - 차트 데이터 배열
 * @param period - 이동평균 기간 (예: 5, 10, 20, 60, 120)
 * @returns 이동평균 데이터 배열
 */
export const calculateMA = (
  data: ChartData[],
  period: number
): { time: number; value: number }[] => {
  if (data.length < period) return [];

  const result: { time: number; value: number }[] = [];
  for (let i = period - 1; i < data.length; i += 1) {
    const slice = data.slice(i - period + 1, i + 1);
    const sum = slice.reduce((acc, item) => acc + item.close, 0);
    const average = sum / period;
    result.push({ time: data[i].timestamp, value: average });
  }

  return result;
};

